import React, { FC } from 'react';

interface SystemBannerProps {
  text: string | null;
}

export const SystemBanner: FC<SystemBannerProps> = ({ text }) => {
  if (!text) {
    return null;
  }

  return (
    <div className="system-banner">
      <span>{' +++ ' + text + ' +++ '}</span>
    </div>
  );
};
